import React from "react";
import Paragraph from "../Paragraph";

const tableStyles = {
  parameters: "table-style",
  palin: "",
  plain: "",
  matrix: "",
};

const itemsStyles = {
  parameters: "",
  palin: "",
  plain: "",
  matrix: "corner",
};

const replace = (table, tableType) => {
  if (!table) {
    return "";
  }

  const matchTds = /<tr><td>(.*?)<\/td>/i;
  let newTable = table.replace(
    "<table",
    `<table class="${tableStyles[tableType] || ""}"`
  );

  if (tableType === "parameters") {
    let match = matchTds.exec(newTable);

    while (match) {
      const [wrapper, inner] = match;

      newTable = newTable.replace(wrapper, `<tr><th>${inner}</th>`);

      match = matchTds.exec(newTable);
    }
  }

  if (table.includes("<th>")) {
    newTable = newTable.replace(
      "<th",
      `<th class="${itemsStyles[tableType] || ""}"`
    );
  } else {
    newTable = newTable.replace(
      "<td",
      `<td class="${itemsStyles[tableType] || ""}"`
    );
  }

  return newTable;
};

const Table = ({ data }) => {
  const {
    table: { text_sq, text_en, id },
    tableType,
  } = data;

  const newTable = {
    id,
    text_sq: replace(text_sq, tableType),
    text_en: replace(text_en, tableType),
  };

  return <Paragraph id={data.id} data={newTable} className="text" />;
};

export default Table;
